<template>
  <el-dialog
    class="comp-container"
    :visible.sync="visible"
    width="30%"
    top="30vh"
    custom-class="comfirm-remove-dialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="title">修改课中昵称</div>
    <div class="input">
      <el-input
        ref="nicknameInput"
        v-model="nickname"
        clearable
        placeholder="请输入昵称"
        :maxlength="15"
        @change="(val) => (nickname = val.trim())"
      ></el-input>
    </div>
    <div class="sync-to-other-course-checkbox" v-if="isShowSyncToOtherCourse">
      <el-checkbox v-model="isSyncToOtherCourse">
        <span class="sync-to-other-course-text">同时修改我的账号昵称</span>
      </el-checkbox>
      <div class="sync-tips">新加入的课程将默认使用该昵称</div>
    </div>
    <div class="footer">
      <el-button @click="handleCancel"> 取消 </el-button>
      <el-button type="primary" @click="handleConfirm" v-preventReClick>
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { updateNickname } from "@saas/server-api/src/live-sdk";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { isAssistant } from "../utils";
export default {
  name: "ChangeNicknameDialog",
  data() {
    return {
      visible: false,
      nickname: "",
      isSyncToOtherCourse: false,
    };
  },
  computed: {
    ...mapState("live", [
      // "allMemberStatus",
      "roomInfo",
      "showChangeNickname",
      "imService",
      "userStatus",
    ]),
    isShowSyncToOtherCourse() {
      const isStudent = this.roomInfo.isStudent;
      if (isStudent) {
        // 学生不展示同步修改账户昵称选项
        return false;
      }
      const isSelf =
        this.showChangeNickname.info.userId === this.userStatus.user_id;
      if (isSelf) {
        // 老师或者助教修改自己展示同步修改账户昵称选项
        return true;
      }
      if (
        this.roomInfo.isTeacher &&
        isAssistant(this.showChangeNickname.info.userId)
      ) {
        // 老师修改助教展示同步修改账户昵称选项
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapMutations("live", [
      "setShowChangeNickname",
      // "setAllMemberStatus",
      "setAllMemberStatusMap",
      "setUserStatus",
    ]),
    handleCancel() {
      this.visible = false;
      this.setShowChangeNickname({
        visible: false,
        info: {},
      });
    },
    handleConfirm() {
      if (!this.nickname || !String(this.nickname).trim().length) {
        this.handleCancel();
        return;
      }
      const params = {
        user_id: this.showChangeNickname.info.userId,
        nickname: this.nickname,
        room_id: this.roomInfo.id,
        is_global: this.isShowSyncToOtherCourse
          ? this.isSyncToOtherCourse
            ? 1
            : 0
          : undefined,
      };
      updateNickname(params)
        .then((res) => {
          if (res.code === 1) {
            const data = {
              userId: params.user_id,
              nickname: params.nickname,
              serverTime: res.serverTime,
            };
            this.imService.sendMGLiveRoomCustomMsg({
              cmdId: 2,
              data: {
                type: "updateNickname",
                data,
              },
            });
            EventBus.$emit("updateNickname", data);
            // 发送响应
            if (window.ipcRenderer) {
              window.ipcRenderer.send("update-nickname", data);
            }

            this.$darkMessage.success("昵称修改成功");
            this.visible = false;
            this.handleCancel();
          } else {
            this.$darkMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    open() {
      this.visible = true;
      this.isSyncToOtherCourse = false;
      this.nickname = this.showChangeNickname?.info?.nickname || "";
      // 打开弹窗后自动聚焦并全选输入框文字
      this.$nextTick(() => {
        this.$refs.nicknameInput?.focus();
        this.$refs.nicknameInput?.$refs?.input?.select();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container ::v-deep {
  .comfirm-remove-dialog {
    width: 327px !important;
    background: #18181b;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(229, 231, 235, 0.04);
    padding: 16px;

    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14px;
      color: #f7f8fa;

      text-align: center;
      .title {
        width: 100%;
        font-weight: 600;
        font-size: 18px;
        color: #ecedee;
        line-height: 28px;
        text-align: left;
        margin-bottom: 16px;
      }
      .input {
        margin-bottom: 20px;
        .el-input__inner {
          background: #27272a;
          box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
          border-radius: 12px 12px 12px 12px;
          color: #fff;
          border: none;
        }
        .el-input {
          .el-input__suffix {
            display: flex !important;
            visibility: visible !important;
            opacity: 1 !important;
          }
          .el-input__clear {
            display: inline-block !important;
            visibility: visible !important;
            opacity: 1 !important;
            color: #86909c;
            &:hover {
              color: #c9cdd4;
            }
          }
        }
      }
      .footer {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          flex: 1;
          background: #165dff;
          border-radius: 12px 12px 12px 12px;
          border: none;
          font-weight: 500;
          font-size: 14px;
          color: #ecedee;
          &.el-button--primary {
            background: #165dff;
            &:hover {
              background: #165dff !important;
            }
            &:focus {
              background: #165dff !important;
            }
          }
          &.el-button--default {
            background: #3f3f46;
          }
        }
      }
    }
    .sync-to-other-course-checkbox {
      width: 100%;
      display: flex;
      align-items: flex-start;
      margin-top: 8px;
      flex-direction: column;
      .sync-to-other-course-text {
        color: #f7f8fa;
        font-size: 14px;
      }
      .sync-tips {
        margin-top: 4px;
        margin-left: 22px;
        font-size: 12px;
        color: #86909c;
        line-height: 18px;
      }
      .el-checkbox__input.is-checked {
        .el-checkbox__inner {
          background: #165dff;
          border-color: #165dff;
        }
      }
      .el-checkbox__inner {
        border-color: #52525b !important;
        &:hover {
          border-color: #165dff;
        }
      }
      .el-checkbox__label {
        padding-left: 0px;
        color: #f7f8fa !important;
      }
    }
    .el-dialog__footer {
      display: none;
    }
  }
}
</style>
